export enum EColumnExtractDataTypes {
    Default = 0,
    Text = 1,
    Number = 2,
    Currency = 3,
    DropDown = 4,
}
